export default "__VITE_ASSET__DTDIIh1x__";